module.exports = __webpack_public_path__ + "img/file-signature-solid.b8c38b57.svg";